import DrawerAccordion from '@components/DrawerAccordion';
import Contactable from '@pages/QuickFilterListCreatorPage/criteriaComponents/Contactable';
import Location from '@pages/QuickFilterListCreatorPage/criteriaComponents/Location';
import MembershipStatusForm from '@pages/QuickFilterListCreatorPage/criteriaComponents/MembershipStatusForm';
import SupporterStatusForm from '@pages/QuickFilterListCreatorPage/criteriaComponents/SupporterStatusForm';
import TasksForm from '@pages/QuickFilterListCreatorPage/criteriaComponents/TasksForm';
import { FilterPanelPartAProps } from './types';

export default function FilterPanelPartA({
  filterCriteria,
  dispatchFilterCriteria,
  accordionStates,
  setAccordionStates,
  disabled,
}: FilterPanelPartAProps) {
  return (
    <>
      <DrawerAccordion
        inUse={filterCriteria.geometries.length > 0}
        headerText="Location"
        expanded={accordionStates.location}
        onChange={(_evt, ex) => setAccordionStates({ ...accordionStates, location: ex })}
        disabled={disabled}
      >
        <Location
          value={filterCriteria.geometries}
          onChange={(payload) => dispatchFilterCriteria({ type: 'setGeometries', payload })}
          operator={filterCriteria.locationOperator}
          onOperatorChange={(newOperator) =>
            dispatchFilterCriteria({ type: 'setLocationOperator', payload: newOperator })
          }
        />
      </DrawerAccordion>
      <DrawerAccordion
        inUse={(filterCriteria.taskelections?.length ?? 0) > 0}
        headerText="Campaign tasks"
        expanded={accordionStates.tasks}
        onChange={(_evt, ex) => setAccordionStates({ ...accordionStates, tasks: ex })}
        disabled={disabled}
      >
        <TasksForm
          electionValue={filterCriteria.taskelections ?? []}
          onChangeElection={(payload) =>
            dispatchFilterCriteria({ type: 'setTaskElections', payload })
          }
          isSinceSpecificElection={filterCriteria.issincespecificelection || false}
          handleSpecificElectionChange={(_e) =>
            dispatchFilterCriteria({
              type: 'setIsSinceSpecificElection',
              payload: filterCriteria.issincespecificelection ? false : true,
            })
          }
          taskChoiceValue={filterCriteria.taskchoices ?? []}
          onChangeTaskChoice={(payload) =>
            dispatchFilterCriteria({ type: 'setTaskChoices', payload })
          }
          taskKindValue={filterCriteria.taskkinds ?? []}
          onChangeTaskKind={(payload) =>
            dispatchFilterCriteria({ type: 'setTaskKinds', payload })
          }
          noteValue={filterCriteria.tasknote ?? ''}
          onChangeValue={(e) =>
            dispatchFilterCriteria({ type: 'setTaskNote', payload: e.target.value })
          }
        />
      </DrawerAccordion>
      <DrawerAccordion
        inUse={filterCriteria.supporterstatuses.length > 0}
        headerText="Rocket status"
        expanded={accordionStates.supporters}
        onChange={(_evt, ex) => setAccordionStates({ ...accordionStates, supporters: ex })}
        disabled={disabled}
      >
        <SupporterStatusForm
          value={filterCriteria.supporterstatuses}
          onChange={(payload, _r, _e) => dispatchFilterCriteria({ type: 'setSupporters', payload })}
        />
      </DrawerAccordion>
      <DrawerAccordion
        inUse={filterCriteria.memberships.length > 0}
        headerText="Membership status"
        expanded={accordionStates.membership}
        onChange={(_evt, ex) => setAccordionStates({ ...accordionStates, membership: ex })}
        disabled={disabled}
      >
        <MembershipStatusForm
          membershipsValue={filterCriteria.memberships}
          onChangeMemberships={(payload) =>
            dispatchFilterCriteria({ type: 'setMemberships', payload })
          }
          branchesValue={filterCriteria.branches}
          onChangeBranches={(payload) => dispatchFilterCriteria({ type: 'setBranches', payload })}
          notRenewing={filterCriteria.notRenewing}
          onChangeNotRenewing={(payload) =>
            dispatchFilterCriteria({ type: 'setNotRenewing', payload })
          }
        />
      </DrawerAccordion>
      <DrawerAccordion
        inUse={
          typeof filterCriteria.contactable.hasEmail !== 'undefined' ||
          Boolean(filterCriteria.contactable.hasPhone)
        }
        headerText="Contactable"
        expanded={accordionStates.contactable}
        onChange={(_evt, ex) => setAccordionStates({ ...accordionStates, contactable: ex })}
        disabled={disabled}
      >
        <Contactable
          value={filterCriteria.contactable}
          onChange={(_e, payload) => dispatchFilterCriteria({ type: 'setContactable', payload })}
        />
      </DrawerAccordion>
    </>
  );
}
